/**
 * @file
 * @author zhousheng
 */
import * as React from 'react';
import LocaleContext from './context';
import { changeModalLocale } from '../modal/locale';
export default class LocaleProvider extends React.Component {
    constructor(props) {
        super(props);
        changeModalLocale(props.locale.Modal);
    }
    // componentDidUpdate(prevProps: LocaleProviderProps) {
    componentDidUpdate() {
        var _a;
        if ((_a = this.props.locale) === null || _a === void 0 ? void 0 : _a.Modal) {
            changeModalLocale(this.props.locale.Modal);
        }
    }
    componentWillUnmount() { }
    render() {
        const { locale, children } = this.props;
        return (<LocaleContext.Provider value={Object.assign(Object.assign({}, locale), { exist: true })}>
                {children}
            </LocaleContext.Provider>);
    }
}
LocaleProvider.defaultProps = {
    locale: {},
};
